export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"ru","messages":{"ru":{"title":"агентство по продаже билетов"},"en":{"title":"tickets sales agency"},"ky":{"title":"агенство по продаже билетов"}},"numberFormats":{"ru":{"currency":{"style":"currency","currency":"RUB","currencyDisplay":"symbol","minimumFractionDigits":0,"maximumFractionDigits":2}},"en":{"currency":{"style":"currency","currency":"USD","currencyDisplay":"symbol","minimumFractionDigits":0,"maximumFractionDigits":2}},"ky":{"currency":{"style":"currency","currency":"KGS","currencyDisplay":"symbol","minimumFractionDigits":0,"maximumFractionDigits":2}}},"dateTimeFormats":{"ru":{"short":{"year":"numeric","month":"short","day":"numeric"},"dateWithMonth":{"month":"short","day":"numeric"},"time":{"hour":"numeric","minute":"numeric","hour12":false},"messageFormat":{"month":"short","day":"numeric","hour":"numeric","minute":"numeric"},"orderFormat":{"month":"short","day":"numeric","weekday":"short"},"long":{"year":"numeric","month":"short","day":"numeric","weekday":"short","hour":"numeric","minute":"numeric"}},"ky":{"short":{"year":"numeric","month":"short","day":"numeric"},"dateWithMonth":{"month":"short","day":"numeric"},"time":{"hour":"numeric","minute":"numeric","hour12":false},"messageFormat":{"month":"short","day":"numeric","hour":"numeric","minute":"numeric"},"orderFormat":{"month":"short","day":"numeric"},"long":{"year":"numeric","month":"short","day":"numeric","weekday":"short","hour":"numeric","minute":"numeric"}},"en":{"short":{"year":"numeric","month":"short","day":"numeric"},"dateWithMonth":{"month":"short","day":"numeric"},"time":{"hour":"numeric","minute":"numeric","hour12":false},"messageFormat":{"month":"short","day":"numeric","hour":"numeric","minute":"numeric"},"orderFormat":{"month":"short","day":"numeric"},"long":{"year":"numeric","month":"short","day":"numeric","weekday":"short","hour":"numeric","minute":"numeric"}}}},
  vueI18nLoader: false,
  locales: ["ru","en"],
  defaultLocale: "ru",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "no_prefix",
  lazy: false,
  langDir: null,
  rootRedirect: null,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: false,
  pages: {"index":false},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"ru"},{"code":"en"}],
  localeCodes: ["ru","en"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "}",
}

export const localeMessages = {}
